import { Outlet, Route } from "react-router";
import { Authenticated } from "@refinedev/core";
import { NavigateToResource } from "@refinedev/react-router";

import { Login } from "@pages/auth/login";

export const PublicRoutes = (
  <Route
    element={
      <Authenticated key="authenticated-outer" fallback={<Outlet />}>
        <NavigateToResource />
      </Authenticated>
    }
  >
    <Route path="/login" element={<Login />} />
  </Route>
);
